import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ColorOptionProps {
  color: string | null;
  onClick: (value: string | null) => void;
  showCrossLine?: boolean;
  children?: ReactNode;
  className?: string;
  selected?: boolean;
}

const ColorOption: FC<ColorOptionProps> = ({ onClick, color, showCrossLine = false, children, className }) => {
  return (
    <div
      className={twMerge(
        'relative z-50 flex h-10 w-8 cursor-pointer items-center justify-center rounded-lg border-glow',
        className,
      )}
      style={{
        backgroundColor: color || '',
        backgroundImage: showCrossLine
          ? 'linear-gradient(45deg, transparent 49%, #FFFFFF80 49%, #FFFFFF80 51%, transparent 51%)'
          : 'none',
      }}
      onClick={() => onClick(color)}
    >
      {children}
    </div>
  );
};

export default ColorOption;
